import React, { useEffect, useMemo, useState } from 'react';

function TaskListEditPanel({ task, onSave, onCancel }) {
  const formatDateInput = (date) => date.toISOString().slice(0, 10);

  const initial = useMemo(() => {
    const now = new Date();
    const todayUtc = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 0, 0, 0));

    const validFrom = task?.validFrom ? new Date(task.validFrom) : todayUtc;
    const validTo = task?.validTo ? new Date(task.validTo) : todayUtc;

    return {
      name: (task?.name ?? '').trim(),
      validFrom: formatDateInput(validFrom),
      validTo: formatDateInput(validTo),
      done: !!task?.done,
    };
  }, [task]);

  const [name, setName] = useState('');
  const [validFrom, setValidFrom] = useState('');
  const [validTo, setValidTo] = useState('');
  const [done, setDone] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setName(initial.name);
    setValidFrom(initial.validFrom);
    setValidTo(initial.validTo);
    setDone(initial.done);
    setError(null);
  }, [initial]);

  const toUTCDate = (dateStr) => {
    const d = new Date(dateStr + 'T00:00:00.000Z');
    return d.getTime();
  };

  const handleOk = () => {
    if (!name.trim()) {
      setError('Nazwa nie może być pusta');
      return;
    }
    if (!validFrom || !validTo) {
      setError('Podaj daty obowiązywania');
      return;
    }

    setError(null);
    onSave({
      id: task.id,
      name: name.trim(),
      validFrom: toUTCDate(validFrom),
      validTo: toUTCDate(validTo),
      done,
    });
  };

  return (
    <div style={{
      background: '#fff',
      borderRadius: 16,
      padding: 32,
      minWidth: 320,
      boxShadow: '0 2px 16px rgba(0,0,0,0.15)',
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
      zIndex: 11000,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      <h3 style={{ marginBottom: 24 }}>Edytuj zadanie</h3>
      <input
        type="text"
        value={name}
        onChange={e => setName(e.target.value)}
        placeholder="Nazwa zadania"
        style={{
          fontSize: '1.1rem',
          padding: '10px',
          borderRadius: 8,
          border: '1px solid #bbb',
          width: 220,
          marginBottom: 16
        }}
        autoFocus
      />
      <input
        type="date"
        value={validFrom}
        onChange={e => setValidFrom(e.target.value)}
        style={{ fontSize: '1.1rem', padding: '10px', borderRadius: 8, border: '1px solid #bbb', width: 220, marginBottom: 12 }}
        title="Od kiedy"
      />
      <input
        type="date"
        value={validTo}
        onChange={e => setValidTo(e.target.value)}
        style={{ fontSize: '1.1rem', padding: '10px', borderRadius: 8, border: '1px solid #bbb', width: 220, marginBottom: 12 }}
        title="Do kiedy"
      />
      <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
        <input
          type="checkbox"
          checked={done}
          onChange={e => setDone(e.target.checked)}
        />
        Wykonane
      </label>
      {error && <div style={{ color: 'red', marginBottom: 12 }}>{error}</div>}
      <div style={{ display: 'flex', gap: 16 }}>
        <button
          onClick={handleOk}
          style={{
            padding: '10px 24px',
            fontSize: '1.1rem',
            fontWeight: 600,
            borderRadius: 8,
            border: '1px solid #6cf',
            background: '#eaf6ff',
            color: '#227',
            cursor: 'pointer',
            transition: 'background 0.2s'
          }}
        >Zapisz</button>
        <button
          onClick={onCancel}
          style={{
            padding: '10px 24px',
            fontSize: '1.1rem',
            fontWeight: 600,
            borderRadius: 8,
            border: '1px solid #f66',
            background: '#fff0f0',
            color: '#a22',
            cursor: 'pointer',
            transition: 'background 0.2s'
          }}
        >Anuluj</button>
      </div>
    </div>
  );
}

export default TaskListEditPanel;
